"use client";

import React from "react";
import {
  Button,
  Container,
  Icon,
  Link,
  List,
  ListItem,
  Typography,
} from "@shc/ui";
import {
  getEventTimeCandidates,
  getNowSanDiego,
  getNextAvailable,
  isUpcomingOrInProgress,
} from "@lib/utilities/events-utils";

interface EventsWidgetProps {
  events?: any[] | undefined;
}

const ProvidersEventsWidget = ({ events = [] }: EventsWidgetProps) => {
  const rawEvents = Array.isArray(events) ? events : [];
  const nowMs = getNowSanDiego();

  const widgetEvents = rawEvents
    .filter((ev: any) => isUpcomingOrInProgress(ev, nowMs))
    .map((ev: any) => ({ ev, next: getNextAvailable(ev, nowMs) }))
    .filter((x: any) => x.next)
    .sort((a: any, b: any) => a.next - b.next)
    .slice(0, 5);

  return (
    <Container className="col-span-6 lg:col-span-4 pt-12 lg:pt-0">
      <Typography paragraph={false} variant={"h2"}>
        Meetings and events
      </Typography>
      
      { widgetEvents.length > 0 ? (
        <>
        <List variant="none">
        { widgetEvents.map(({ ev }: any) => {
          const title = ev.title ?? ev.name ?? "Untitled Event";
          const nextTs = getEventTimeCandidates(ev)[0];
          const displayed = nextTs;
          const dateStr = (() => {
            const next = displayed ? new Date(displayed) : null;
            if (!next) return "";
            const opts: Intl.DateTimeFormatOptions = {
              weekday: "long",
              month: "long",
              day: "numeric",
              year: "numeric",
            };
            return new Intl.DateTimeFormat("en-US", opts).format(next);
          })();
          const key =
            ev.objectID ??
            ev.objectId ??
            ev.id ??
            `${title}-${nextTs ?? "no-date"}`;

          return (
            <ListItem className="my-8 providers-home" key={key}>
              <Link
                href={
                  ev.eventUrl ?? ev.eventurl ?? "/providers/search/events"
                }
                target="_blank"
                rel="noopener noreferrer"
                className='no-underline hover:underline'
              >
                {title}
              </Link>
              <div className="text-sm text-gray-700">{dateStr}</div>
            </ListItem>
          );
        })}
        </List>
         <Button
            variant="filled"
            href="/providers/search/events"
            size="md"
            width="lg"
          >
            View all meetings and events
          </Button>
        </>
      ) : (
          <List variant="none">
            <ListItem className="my-8 providers-home">
              <Typography variant="body-semibold">
                <Icon
                  icon="calendar-days"
                  className="text-primary pr-2"
                />
                No events or meetings available</Typography>
            </ListItem>
            <ListItem className="my-3 providers-home">
              <Typography variant="small-body">There are no upcoming events or meetings. Please check back again soon.</Typography>
            </ListItem>
          </List>
        )}
     
    </Container>
  );
};

export default ProvidersEventsWidget;
